import TableReportHelper from "report/helper"

import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport"
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport"
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport"
import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport"

export default async function lcReport(indicador, visita) { // pdf da visita ou pdf do laudo
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor

    const apontamentos = visita.getApontamentosByIndicador(indicador)

    const content = []

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const configIndicador = {
            showTrator: false,
            showImplemento: false,
            showFrente: false,
            addHeaderField: [
                {
                    field: "talhao.area",
                    label: "Área do Talhão (ha)",
                    width: 90,
                    valueGetter: (a) => {
                        let sumArea = 0

                        if (a.talhao.length) {
                            for (let i = 0; i < a.talhao.length; i++) {
                                sumArea = sumArea + parseFloat(a.talhao[i].area)
                            }

                            return sumArea.toFixed(2)
                        } else {
                            return a.talhao.area
                        }
                    },
                },
                {
                    field: "percentBrocasInternas",
                    label: "Brocas Internas",
                    width: 70,
                    secondConformidadeField: (a) => {
                        return {
                            conformidade: "percentBrocasInternas",
                            status: IndicadorClass.getConformidadeStatus(
                                a.percentBrocasInternas,
                                params.metaBrocasInternas,
                                null,
                                visita.cliente
                            ),
                            config: { alignment: "right" }
                        }
                    }
                },
                { field: "totalBrocas", label: "Total Brocas Encontradas", width: 110 },
                { field: "totalCanas", label: "Total Canas Avaliadas", width: 110 },
            ]
        }

        content.push(
            [
                await apontamentoHeaderLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    params,
                    "% Brocas",
                    configIndicador,
                ),

                await apontamentoColetasLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    ["Nº de Brocas Encontradas", "Nº de Canas Avaliadas"],

                    // prettier-ignore
                    (h) => [
                        h.numberField("numBrocas"),
                        h.numberField("numCanas"),

                    ],
                    ["*", "*"]
                ),
                apontamentoImagesReport(visita, indicador, apontamento),
                apontamentoObservacaoReport(visita, indicador, apontamento),

                h.space(),
            ]
        )
    }

    return content
}
